import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import * as _ from 'lodash';
import { UtilService } from './../../core/services/util.service';
import { HttpService } from '../../core/services/http.service';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class MessageService {
    updateCount$ = new Subject();
    constructor(
        private http: HttpService,
        private utilService: UtilService
    ) { }

    getMsgList(par) {
        const params = new HttpParams()
            .set('pageNumber', par.pageNumber)
            .set('pageSize', par.pageSize)
            .set('status', par.status)
            .set('keyword', par.keyword);
        return this.http.get('api/message/list', { params: params })
            .switchMap(res => this.http.mapRes(res));
    }

    newCount() {
        const params = new HttpParams()
            .set('status', '0');
        return this.http.get('api/message/notifyNum', { params })
            .switchMap(res => this.http.mapRes(res));
        // .map(res => ({ num: 0 }));
    }

    markAsRead(id: string): Observable<any> {
        return this.http.post('api/message/updateStatus', { id: id })
            .switchMap(res => this.http.mapRes(res))
            .do(x => {
                this.updateCount();
            });
    }

    updateCount() {
        this.updateCount$.next(true);
    }

}





// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/services/message.service.ts